import React, { useState, useEffect } from 'react';
import SearchRegionsWidget from '../../../shared/components/SearchRegionsWidget';
import tourvisorAPI from '../../api/tourvisorAPI';
import RegionsWidgetOpen from '../../../shared/components/RegionsWidgetOpen';
import filteredRegionsTurkey from './dictionaries/regionsTurkey';
import subregionsTurkey from './dictionaries/subregionsTurkey';

const Regions = ({
  value = [],
  subvalue = [],
  onSubChoose,
  onChoose,
  country,
  isOpen = true,
}) => {
  const [regions, setRegions] = useState(value);
  const [items, setItems] = useState([]);
  const [title, setTitle] = useState('Выберите курорт');

  useEffect(() => {
    async function fetchRegions() {
      setItems(getRegions({ regcountry: country }));
      setRegions([]);
      setTitle('Выберите курорт');
    }
    fetchRegions();
  }, [country]);

  useEffect(() => {
    setRegions(value);
  }, [value]);

  useEffect(() => {
    // console.log(value, subvalue, items, regions);
    if (regions.length + subvalue.length > 4) {
      setTitle(`Выбрано ${regions.length + subvalue.length} курортов`);
    } else if (regions.length + subvalue.length > 1) {
      setTitle(`Выбрано ${regions.length + subvalue.length} курорта`);
    } else if (regions.length + subvalue.length === 1) {
      setTitle(`Выбран 1 курорт`);
    } else if (regions.length + regions.length === 0) {
      setTitle(`Выберите курорт`);
    }
  }, [value, subvalue, items, regions]);

  const getRegions = async (params) => {
    const requestQuery = new URLSearchParams(params).toString();
    const resRegion = await tourvisorAPI.dics('region', requestQuery);
    const resSubregion = await tourvisorAPI.dics('subregion', requestQuery);

    let regionsList, subregionList;

    if (country === 4 || country === '4') {
      regionsList = filteredRegionsTurkey;
      subregionList = subregionsTurkey;
    } else {
      regionsList = resRegion.lists.regions.region;
      subregionList = resSubregion.lists
        ? resSubregion.lists.subregions.subregion
        : [];
    }

    const regionsListWithSubregions = regionsList.map((region) => {
      if (region.children) {
        region.children.forEach((child) => {
          child.subitems = subregionList.filter(
            (subregion) => subregion.parentregion === child.id
          );
        });
        return region
      } else
        return {
          ...region,
          subitems: Array.isArray(subregionList)
            ? subregionList.filter(
                (subregion) => subregion.parentregion === region.id
              )
            : [],
        };
    });
    setItems(regionsListWithSubregions);
  };

  const setSubRegionsOnChoose = (v) => {
    const newSubvalue = [...subvalue];
    const index = newSubvalue.indexOf(v);
    if (index !== -1) {
      newSubvalue.splice(index, 1);
    } else {
      newSubvalue.push(v);
    }
    onSubChoose(newSubvalue);
  };

  const setRegionsOnChoose = (v) => {
    const newValue = [...value];
    const index = newValue.indexOf(v);

    if (index !== -1) {
      newValue.splice(index, 1);
    } else {
      newValue.push(v);
    }

    onChoose(newValue);
  };

  return isOpen ? (
    <RegionsWidgetOpen
      type="multiselect"
      label="курорт"
      title={`${title}`}
      items={items}
      value={value}
      subvalue={subvalue}
      width={'unset'}
      onChoose={setRegionsOnChoose}
      onSubChoose={setSubRegionsOnChoose}
    />
  ) : (
    <SearchRegionsWidget
      type="multiselect"
      label="курорт"
      title={`${title !== 'Любой' ? title : 'Любой курорт'}`}
      items={items}
      value={regions}
      subvalue={subvalue}
      width={220}
      onSubChoose={setSubRegionsOnChoose}
      onChoose={setRegionsOnChoose}
      cssClass="resort"
    />
  );
};

export default Regions;
